import * as R from 'ramda';
import { Action } from 'redux';
import { ActionType } from './actionType';
import { AppState } from './appState';
import { keyFor } from '../api/module';


type ClearLoadingStateAction = {
  type: ActionType.ClearLoadingStateAction;
  actionType: ActionType;
  requestId: string | number | undefined;
}


export const clearLoadingStateAction = (
  actionType: ActionType,
  requestId: string | number | undefined,
): ClearLoadingStateAction => ({
  type:       ActionType.ClearLoadingStateAction,
  actionType: actionType,
  requestId:  requestId,
});

export const clearLoadingStateReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.ClearLoadingStateAction) {
    return state;
  }

  const action = incomingAction as ClearLoadingStateAction;

  const { actionType, requestId } = action;

  const key = keyFor(actionType, requestId ?? actionType);

  return R.dissocPath(['loading', key], state);
};
